import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Snackbar } from '@mui/material';
import { AnnouncementForm } from './form';
import { createAnnouncement } from '../../lib/announcements-api';
import { extractApiError } from '../../lib/api-client';
import { useT } from '../../i18n';

export function AnnouncementCreatePage() {
  const t = useT();
  const nav = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState<{ message: string; severity: 'success' | 'error' } | null>(null);

  return (
    <>
      <AnnouncementForm
        submitting={submitting}
        onCancel={() => nav('/announcements')}
        onSubmit={async (values) => {
          setSubmitting(true);
          try {
            const out = await createAnnouncement(values);
            if (out.notification) {
              setToast({
                severity: 'success',
                message: t('ann.publishedNotif', { count: out.notification.total_recipients }),
              });
            } else {
              setToast({ severity: 'success', message: t('ann.savedDraft') });
            }
            // Defer nav slightly so the toast registers
            setTimeout(() => nav('/announcements'), 400);
          } catch (e) {
            setToast({ severity: 'error', message: extractApiError(e).message });
            throw e;
          } finally {
            setSubmitting(false);
          }
        }}
      />
      <Snackbar
        open={!!toast}
        autoHideDuration={4000}
        onClose={() => setToast(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        {toast ? <Alert severity={toast.severity}>{toast.message}</Alert> : undefined}
      </Snackbar>
    </>
  );
}
